module.exports = __webpack_public_path__ + "img/open-source_img.b0f1941f.svg";